module.exports = __webpack_public_path__ + "img/logo.dec00b85.png";